import React, { useEffect, useMemo, useState } from 'react';
import { Card, Bubble,Col, Row } from "tea-component";
import moment from 'moment';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { useLocal, useSelectorMap, useWeekDay } from '@/pages/dashboard/utils/customHook';
import usePcOverviewLocalesIntl from '@/pages/dashboard/pages/overview/_config/usePcOverviewLocalesIntl';
import { useIntl, useSelector, shallowEqual } from 'umi';
import { formatNum, getSystemColor, handleDownload } from '@/pages/dashboard/utils/utils';
import { getEchartTooltipText } from '@/pages/dashboard/components/EchartsBubble';
import BarChart from '@/pages/dashboard/components/Chart/components/BarChart';
import LineChart from '@/pages/dashboard/components/Chart/components/LineChart';
import MiniTable from '@/pages/dashboard/components/MiniTable';
import Abnormal from '@/pages/dashboard/components/Abnormal';
import { xAxisHighLight } from '@/pages/dashboard/components/Chart/_config/plug';
import { TABLE_CELL_PADDING_LEFT, TABLE_CELL_PADDING_RIGHT } from '@/pages/home/_config/config';
import getSystemLegend from "@/pages/dashboard/components/CountryRegionRowItem/CountryTabChartsItem/utils";
import { getSystemFlag } from '../../../_config/system';
import useData from './useData';

import "@/pages/dashboard/assets/scss/page/Overlay/components/tableCard.scss";
const PUBLIC_HEIGHT = 290;

const getSumValue = (arr: any[] = [],isBar:boolean) => {
  const arrObject = isBar ? arr?.slice(0, arr.length - 1) :arr;
  const sumValue = arrObject?.reduce((pre, cur) => {
    if (!isNaN(parseFloat(cur.value))) pre += parseFloat(cur.value);
    return pre;
  }, 0);
  return (sumValue && formatNum(sumValue, false, true)) || '0';
};


export default function BreakdownContext(props: any) {
  const { filterVal,filterLoading,type, componetIndex, isPlatform=false } = props;
  const metricsData = useData(
    filterVal,
    filterLoading,
  );
  
  const { formatMessage } = useIntl(); // 中英切换方法
  const { getSelectorText } = useSelectorMap();
  const { data, loading, error } = metricsData || {};
  const channelsNewUserV2Data = data?.system_of_new_user?.metrics?.filter((item: { values: { filter: (arg0: (items: any) => boolean) => { (): any; new(): any; length: number; }; }; }) => item.values?.filter((items: string) => items !== '')?.length > 0) || [];
  const channelsNewUserV2Name = channelsNewUserV2Data?.map((items: { name: any; }) => items?.name) || [];
  const { selector,gameCode } = useSelector((state: any) => ({
    selector: state?.dashboardSetting?.selector ?? {},
    gameCode: state.dashboard?.currentGame?.game_code
  }),shallowEqual);
  const [iseye, setIseye] = useState(true);

  const rightIcon = [
    {
      type: 'eyes',
      icon: iseye ? 'open-eyes' : 'eyes-closed',
      Bubble: iseye ? formatMessage({ id: 'common_show_values' }) : formatMessage({ id: 'common_hide_values' }),
    },
    {
      type: 'column',
      icon: "column-chart",
      Bubble: formatMessage({ id: 'common_bar_chart' }),
    },
    {
      type: 'discount',
      icon: "discount-chart",
      Bubble: formatMessage({ id: 'common_line_chart' }),
    },
    {
      type: 'sheet',
      icon: "sheet",
      Bubble: formatMessage({ id: 'common_table' }),
    },
  ];

  const [isLine, setIsLine] = useState(rightIcon[1].type);
  const { locale, getLocalText } = useLocal('overview', '_', gameCode);
  const { BREAKDOWN_METRICS } = usePcOverviewLocalesIntl();

  // 指标对象
  const metricsObj = BREAKDOWN_METRICS[type];
  //* ********************* 两个卡片相关数据 start **********************************/
  const [legendData, setLegendData] = useState([[], []]);
  const [barxAxisData, setBarxAxisData] = useState([[], []]);
  const [linexAxisData, setLinexAxisData] = useState([[], []]);
  const [barSeries, setBarSeries] = useState([[], []]);
  const [lineSeries, setLineSeries] = useState([[], []]);
  const [tableList, setTableList] = useState([[], []]);
  //* ********************* 两个卡片相关数据 end ************************************/

  // 两个卡片表格配置
  const [tableOption, setTableOption] = useState([[], []]);

  // 卡片是否有数据
  const [isNoData, setIsNoData] = useState([true, true]);
  const { getWeekDayStr, getWeekDay } = useWeekDay();

  const lineFormatterFunc2 = (params: any[] | undefined, timeType = 'DAY', sumName = 'Total', isChannel = false) => {
    // 'New Users' sort
    let data = sumName === formatMessage({ id: 'overview_monthly_New_Users' }) ? [...params].sort((f, s) => s.value - f.value) : [...params];
    data = data.map(({ seriesName, value, color }) => ({
      name: seriesName,
      metricsNum: formatNum(value, false, true),
      icon: isPlatform ? getSystemFlag(seriesName) : '',
      color,
      customColor: isPlatform ? getSystemColor(seriesName.toLowerCase().replace(/\s/g, '')) : '',
    }));

    return getEchartTooltipText({
      title: getWeekDayStr(moment(`${params[0].axisValue}`).format(timeType === 'MONTH' ? 'YYYY-MM' : 'YYYY-MM-DD'), timeType),
      metricsName: '',
      hasSum: true,
      sumName,
      sumNum: getSumValue(params,false),
      data,
      isSort: isChannel,
      isRemoveNull: isChannel,
    });
  };
  const barFormatterFunc2 = (params: any[] | undefined, timeType = 'DAY', sumName = 'Total', isChannel = false) => {
    // 'New Users' sort
    let data = sumName === formatMessage({ id: 'overview_monthly_New_Users' }) ? [...params].sort((f, s) => s.value - f.value) : [...params];
    data = data.map(({ seriesName, value, color, }) => ({
      name: seriesName,
      metricsNum: formatNum(value, false, true),
      icon: isPlatform  ? getSystemFlag(seriesName) : '',
      customColor: isPlatform ? getSystemColor(seriesName.toLowerCase().replace(/\s/g, '')) : '',
      color
    }));
    return getEchartTooltipText({
      title: getWeekDayStr(moment(`${params[0].axisValue}`).format(timeType === 'MONTH' ? 'YYYY-MM' : 'YYYY-MM-DD'), timeType),
      metricsName: '',
      hasSum: true,
      sumName,
      sumNum: getSumValue(params,true),
      data,
      isSort: isChannel,
      isRemoveNull: isChannel,
    });
  };

  // 日期格式化
  const dateFormat = (type = 'DAY', value: string, isTable = false): string => {
    if (!value) return '';
    // MONTH维度时，x轴和表格显示为YYYY-MM
    // Day和Week维度时, x轴显示为 MM-DD, 表格显示为YYYY-MM-DD
    const formatStr = type === 'MONTH' ? "YYYY-MM" : (isTable ? "YYYY-MM-DD" : "MM-DD");
    return moment(value).format(formatStr);

  };

  // 下载
  const downloadFun = useMemo(() => (
    () => {
      if (isNoData[componetIndex]) return;
      const tableConfig = {
        option: tableOption[componetIndex],
        downloadData: tableList[componetIndex]
      };
      handleDownload(tableConfig, metricsObj.BREAKDOWN_AND_NEWUSERS_TITLE[componetIndex]);
    }
  ), [isNoData, tableOption, locale]);

  useEffect(() => {
    if (data === null) return;

    // 第一个卡片
    setIsNoData([!data?.[metricsObj.BREAKDOWN_TOTAL], !data?.system_of_new_user_total]);
    let legendData1: (string | undefined)[] = [];
    if (Object.keys(data?.[metricsObj.BREAKDOWN]?.[0] || [])?.length > 0) {
      legendData1 = [
        getLocalText('breakdown_legend1'),
        getLocalText('breakdown_legend2'),
        getLocalText('breakdown_legend3'),
      ];
    }
    // 第二个卡片
    const legendData2 = channelsNewUserV2Name?.map((item: any) => getSelectorText('os', item));

    setLegendData([legendData1, legendData2]);

    // 卡片柱状图X轴刻度
    // 第一个卡片
    const barxAxisData1 = data?.[metricsObj.BREAKDOWN]?.reduce((org: any[], t: { date: any; }) => {
      org.push(t?.date);
      return org;
    }, []) || [];
    // 第二个卡片
    const barxAxisData2 = data?.system_of_new_user?.dates || [];
    setBarxAxisData([barxAxisData1, barxAxisData2]);
    setLinexAxisData([barxAxisData1, barxAxisData2]);

    // 柱状图series配置
    // 第一个卡片
    const nameMap = {
      [getLocalText('breakdown_legend1')]: 'new_users',
      [getLocalText('breakdown_legend2')]: 'retention_users',
      [getLocalText('breakdown_legend3')]: 'return_users',
    };
    const barSeries1 = legendData1.reduce((org: any, t) => {
      org.push({
        name: t,
        type: 'bar',
        stack: "Total",
        barMaxWidth: 80,
        barCategoryGap: '50%',
        cursor: 'pointer',
        data: data?.[metricsObj.BREAKDOWN].reduce((o: number[], v: { [x: string]: string; }) => {
          const name = nameMap[t];
          o.push(parseFloat(v[name?.toLowerCase()?.replace(' ', '_')]));
          return o;
        }, []) || null,
      });
      return org;
    }, []) || [];


    // 第二个卡片
    const barSeries2 = channelsNewUserV2Name?.map((name: string, index: string | number) => {
      const metricValue = channelsNewUserV2Data[index] || {};
      let data = metricValue?.name === name ? metricValue.values : [];
      data = data.map((item: string) => parseInt(item, 10));
      const osName = getSelectorText('os', name).toLowerCase().replace(/\s/g, '');
      const color = getSystemColor(osName);
      return {
        name: getSelectorText('os', name),
        type: 'bar',
        stack: "Total",
        barMaxWidth: 80,
        barCategoryGap: '50%',
        cursor: 'pointer',
        data,
        itemStyle: {
          color
        },
      };
    });
    setBarSeries([barSeries1, barSeries2]);

    // 折线图series配置
    // 第一个卡片
    const lineSeries1 = legendData1.reduce((org: any, t) => {
      org.push({
        name: t,
        type: 'line',
        barMaxWidth: 80,
        cursor: 'pointer',
        symbolSize: 4,
        showAllSymbol: false,
        symbol: 'circle',
        data: data?.[metricsObj.BREAKDOWN].reduce((o: { value: number; }[], v: { [x: string]: string; }) => {
          const name = nameMap[t];
          o.push({
            value: parseFloat(v[name?.toLowerCase()?.replace(' ', '_')]),
          });
          return o;
        }, []) || null,
      });
      return org;

    }, []) || [];

    // 第二个卡片
    const lineSeries2 = channelsNewUserV2Name?.map((name: string, index: string | number) => {
      const metricValue = channelsNewUserV2Data[index] || {};
      const data = metricValue?.name === name ? metricValue.values : [];
      const osName = getSelectorText('os', name).toLowerCase().replace(/\s/g, '');
      const color = getSystemColor(osName);

      // Customize the properties to match lineSeries1
      return {
        name: getSelectorText('os', name),
        type: 'line',
        symbolSize: 4,
        showAllSymbol: false,
        symbol: 'circle',
        data: data.map((value: string) => ({
          value: parseFloat(value),
        })),
        itemStyle: {
          color,
        },
      };
    });

    setLineSeries([lineSeries1, lineSeries2]);

    // 表格数据
    // 第一个卡片数据
    const tableList1 = data?.[metricsObj.BREAKDOWN]?.reduce((org: any[], t: { total: any; }) => {
      org.push(Object.assign({ [metricsObj.AU]: t?.total || 0 }, t));
      return org;
    }, []) || [];
    const { dates = [], total = [] } = data?.system_of_new_user || {};
    const tableList2 = dates?.map((date: any, index: string | number) => ({
      date,
      'New Users': total[index],
      ...channelsNewUserV2Data.reduce((acc: { [x: string]: any; }, metric: { name: string; values: { [x: string]: any; }; }) => {
        acc[getSelectorText('os', metric?.name)] = metric?.values?.[index];
        return acc;
      }, {}) // 还是会有名称覆盖问题
    })) || [];
    setTableList([tableList1, tableList2]);

    // 表格配置项
    // 第一个卡片表格固定列
    const tableOption1: any = [
      {
        key: "date",
        align: "left",
        fixed: "left",
        width: 120 + TABLE_CELL_PADDING_LEFT + TABLE_CELL_PADDING_RIGHT,
        header: getLocalText('table_date'),
        render: (cvm: { date: string; }) => {
          const weekDay = getWeekDay(cvm?.date);
          const isSunOrSat = weekDay === 'Sun' || weekDay === 'Sat' || weekDay === '周日' || weekDay === '周六';
          return <>
            <span className='table-text'>{dateFormat(type, cvm?.date, true)}</span>
            {type?.toLowerCase() !== 'month' && <span className={isSunOrSat ? 'text-week-b' : 'text-week'}>{weekDay}</span>}
          </>;
        },
      },
      {
        key: metricsObj.AU,
        align: "right",
        fixed: "left",
        width: 80 + TABLE_CELL_PADDING_LEFT + TABLE_CELL_PADDING_RIGHT,
        header: metricsObj.AU,
        render: (cvm: { [x: string]: string | number; }) => (<span>{formatNum(cvm[metricsObj.AU], false, true)}</span>),
      },
    ];
    // 第一个卡片表格变化列
    const keyNameMap = {
      new_users: getLocalText('breakdown_legend1'),
      retention_users: getLocalText('breakdown_legend2'),
      return_users: getLocalText('breakdown_legend3'),
    };
    Object.keys(tableList1[0] || []).forEach((t) => {
      if (t === 'date' || t === 'total' || t === metricsObj.AU) return;
      tableOption1.push({
        key: t,
        align: "right",
        width: 80 + TABLE_CELL_PADDING_LEFT + TABLE_CELL_PADDING_RIGHT,
        header: keyNameMap[t],
        render: (cvm: { [x: string]: string | number; }) => (<span>{formatNum(cvm[t], false, true)}</span>),
      });
    });
    // 第二个卡片表格固定列
    const tableOption2: any = [
      {
        key: "date",
        align: "left",
        fixed: "left",
        width: 120 + TABLE_CELL_PADDING_LEFT + TABLE_CELL_PADDING_RIGHT,
        header: getLocalText('table_date'),
        render: (cvm: { date: string; }) => {
          const weekDay = getWeekDay(cvm?.date);
          const isSunOrSat = weekDay === 'Sun' || weekDay === 'Sat' || weekDay === '周日' || weekDay === '周六';
          return <>
            <span className='table-text'>{dateFormat(type, cvm?.date, true)}</span>
            {type?.toLowerCase() !== 'month' && <span className={isSunOrSat ? 'text-week-b' : 'text-week'}>{weekDay}</span>}
          </>;
        },
      },
      {
        key: "New Users",
        align: "right",
        fixed: "left",
        width: 80 + TABLE_CELL_PADDING_LEFT + TABLE_CELL_PADDING_RIGHT,
        header: getLocalText('table_new_users'),
        render: (cvm: { [x: string]: string | number; }) => (<span>{formatNum(cvm['New Users'], false, true)}</span>),
      },
    ];
    // 第二个卡片表格变化列
    Object.keys(tableList2[0] || []).forEach((t) => {
      if (t === 'date' || t === 'New Users') return;
      tableOption2.push({
        key: t,

        align: "right",
        width: 80 + TABLE_CELL_PADDING_LEFT + TABLE_CELL_PADDING_RIGHT,
        header: getSelectorText('os', t),
        render: (cvm: { [x: string]: string | number; }) => (<span>{formatNum(cvm[t], false, true)}</span>),
      });
    });
    setTableOption([tableOption1, tableOption2]);
  }, [locale, data]);

  return (
    <Card className='overlay-line'>
      <Card.Body
        title={
          <div className='overlay-line-title-flex'>
            <div className='dbd-overlay-line-title' >
              <div className='overlay-line-title'>{metricsObj.BREAKDOWN_AND_NEWUSERS_TITLE[componetIndex]}</div>
              {/* <SvgIcon className='overlay-line-title-icon' type='arrow-right'></SvgIcon> */}
            </div>
          </div>
        }
        operation={
          !isNoData[componetIndex] &&
          <div className='overlay-line-flex'>
            {
              rightIcon.map(e => <Bubble
                key={e.type}
                dark
                placement="top"
                content={e.Bubble}
              >
                <div
                  className='overlay-line-item'
                  onClick={() => {
                    if (e?.type === 'eyes') {
                      setIseye(!iseye);
                      return;
                    }
                    setIsLine(e.type);
                  }}>
                  <SvgIcon className={e.type == isLine ? 'overlay-line-action' : 'overlay-line-icon'} type={e.icon} />
                </div>
              </Bubble>)
            }
            <Bubble dark placement="top" content=''>
              <i onClick={downloadFun}><SvgIcon className='overlay-line-down' type='download' /></i>
            </Bubble>
          </div>
        }
      >
        <Row>
          {
            (isLine === rightIcon[1].type) ? <Col>
              <div className='dbd-overlay-chart'>
                <Abnormal isLoading={loading} isError={error} isNoData={isNoData[componetIndex]}
                  style={{ height: PUBLIC_HEIGHT }}
                  component={<BarChart
                    key={locale}
                    height={PUBLIC_HEIGHT}
                    legendData={legendData[componetIndex]}
                    xAxisData={barxAxisData[componetIndex]}
                    series={barSeries[componetIndex]}
                    formatterFunc={(params: any) => barFormatterFunc2(params, type, componetIndex ? metricsObj?.NEW : metricsObj?.AU, !!componetIndex)}
                    setOtherConfigFunc={(opt: { xAxis: { axisLabel: { formatter: (value: any) => string; }; }[]; legend: { bottom: number; }; }) => {
                      opt.xAxis[0].axisLabel.formatter = function (value: string) {
                        return dateFormat(type, value);
                      };
                      opt = xAxisHighLight(opt, {
                        formatter: (value: { value: string; }) => dateFormat(type, value?.value)
                      });
                      // pc console游戏os来源legend显示图标
                      getSystemLegend(opt, selector);
                      opt.legend.bottom = -4;
                      return opt;
                    }}
                    isStackBar={iseye}
                  />}
                />
              </div>
            </Col> : <></>
          }
          {
            isLine === rightIcon[2].type ? <Col>
              <div className='dbd-overlay-chart'>
                <Abnormal isLoading={loading} isError={error} isNoData={isNoData[componetIndex]}
                  style={{ height: PUBLIC_HEIGHT }}
                  component={<LineChart
                    key={locale}
                    height={PUBLIC_HEIGHT}
                    legendData={legendData[componetIndex]}
                    xAxisData={linexAxisData[componetIndex]}
                    series={lineSeries[componetIndex]}
                    formatterFunc={(params: any) => lineFormatterFunc2(params, type, componetIndex ? metricsObj?.NEW : metricsObj?.AU, !!componetIndex)}
                    setOtherConfigFunc={(opt: { xAxis: { axisLabel: { formatter: (value: any) => string; }; }[]; legend: { bottom: number; }; }) => {
                      opt.xAxis[0].axisLabel.formatter = function (value: string) {
                        return dateFormat(type, value);
                      };
                      opt = xAxisHighLight(opt, {
                        formatter: (value: { value: string; }) => dateFormat(type, value?.value)
                      });
                      // pc console游戏os来源legend显示图标
                      getSystemLegend(opt, selector);
                      opt.legend.bottom = -4;
                      return opt;
                    }}
                  />}
                />
              </div>
            </Col> : <></>
          }
          {
            isLine == rightIcon[3].type ? <Col>
              <Abnormal isLoading={loading} isError={error} isNoData={isNoData[componetIndex]} style={{ height: PUBLIC_HEIGHT }}
                component={
                  <MiniTable
                    height={PUBLIC_HEIGHT}
                    loading={loading}
                    tableOption={tableOption[componetIndex]}
                    tableList={tableList[componetIndex]}
                    scrolLableVal={{
                      maxHeight: 247,
                      minHeight: 247,
                    }}
                  />
                }
              />
            </Col> : <></>
          }
        </Row>
      </Card.Body>
    </Card>
  );
};
